<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'groupManager' }">商品分组</el-breadcrumb-item>
            <el-breadcrumb-item>编辑商品分组</el-breadcrumb-item>
        </el-breadcrumb>

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="first">
                <el-form  :model="ecxForm" :rules="actrules" ref="ecxForm" label-width="150px" class="demo-ruleForm"  >
                    <el-form-item label="售货机ID" prop="kioskNo">
                        <el-select class="m-1" v-model="ecxForm.kioskNo" placeholder="机器编号" @change="proList()">
                            <!--<el-option label="T1-A101" value="T1-A101" v-show="this.getcookie('storeId')=='store001'">T1-A101</el-option>-->
                            <el-option label="K1-A112" value="K1-A112" v-show="this.getcookie('storeId')=='store001'">K1-A112</el-option>
                            <el-option label="K1-A113" value="K1-A113" v-show="this.getcookie('storeId')=='store001'">K1-A113</el-option>
                            <el-option label="X2-A179" value="X2-A179" v-show="this.getcookie('storeId')=='0001'">X2-A179</el-option>
                            <el-option label="X2-A173" value="X2-A173" v-show="this.getcookie('storeId')=='0001'">X2-A173</el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="商品分组名称" prop="groupName">
                        <el-input v-model="ecxForm.groupName" placeholder="商品分组名称" style="width: 40%;" ></el-input>
                    </el-form-item>

                    <el-form-item label="第一优先级" prop="firstPriority">
                        <el-select class="m-1" v-model="ecxForm.firstPriority" placeholder="第一优先级">
                            <el-option label="无" value="0" >无</el-option>
                            <el-option label="按商品序号升序" value="1" >按商品序号升序</el-option>
                            <el-option label="按商品序号降序" value="2">按商品序号降序</el-option>
                            <el-option label="按商品销售量升序" value="3">按商品销售量升序</el-option>
                            <el-option label="按商品销售量降序" value="4">按商品销售量降序</el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="第二优先级" prop="secondPriority">
                        <el-select class="m-1" v-model="ecxForm.secondPriority" placeholder="第一优先级">
                            <el-option label="无" value="0" >无</el-option>
                            <el-option label="按上架时间升序" value="1" >按上架时间升序</el-option>
                            <el-option label="按上架时间降序" value="2">按上架时间降序</el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary"  @click="submitForm()" id="primary" :disabled="isorgsubmit">保 存</el-button>
                        <el-button @click="close()">关闭</el-button>
                    </el-form-item>

                </el-form>
            </el-tab-pane>

            <el-tab-pane label="商品清单" name="second" style="overflow-y:scroll;overflow-x:hidden;">
                <div>
                    <el-button type="primary" @click="dialogVisible = true">添加商品</el-button>
                    <el-button type="primary" @click="batchDel()" :disabled="batchDelFlag">批量移除</el-button>
                    <el-select class="m-1" v-model="proCondition" placeholder="选择查询条件" style="margin-left: 30%;" @change="changePro()">
                        <el-option label="所有商品" value="0" >所有商品</el-option>
                        <el-option label="已上架商品" value="1" >已上架商品</el-option>
                        <el-option label="未上架商品" value="2">未上架商品</el-option>
                    </el-select>
                    <el-input v-model="proName" placeholder="搜索商品名称" style="width: 230px;margin-left: 20px;" @change="proGroupList()"></el-input>
                </div>
                <div>
                    <el-table ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width: 100%;" @selection-change="batchhandleSelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="productName" label="商品名称"></el-table-column>
                        <el-table-column prop="kioskNo" label="售货机ID"></el-table-column>
                        <el-table-column prop="proStatus" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.proStatus != '0'">已上架</span>
                                <span v-else >未上架</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sequenceNum" label="序号">
                            <template slot-scope="scope">
                                <el-input onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="scope.row.sequenceNum" style="width: 80%;" @change="updateProGroup(scope.row)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template scope="scope" >
                                <el-button type="primary"  @click="delProGroup(scope.row.groupId,scope.row.SKU)" size="small" >移除分组</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="block">
                        <el-pagination
                                @current-change="proCurrentChange"
                                @size-chahange="proSizeChange"
                                :current-page="procurrentpage"
                                :page-count="propagesCount"
                                :page-sizes="propagesizes"
                                :page-size="propagesize"
                                :total="propagesCount"
                                layout=" total, prev, pager, next, jumper"
                        >
                        </el-pagination>
                    </div>
                </div>
                <div>
                    <el-dialog title="添加商品" :visible.sync="dialogVisible" width="70%;height: 500px;" :before-close="handleClose" :modal="false">
                        <el-form :inline="true" :model="topForm" ref="topForm">
                            <el-select class="m-1" v-model="topForm.categoriesName" placeholder="品类" @change="chageProList()">
                                <el-option label="全部品类" value="" >全部品类</el-option>
                                <el-option
                                        v-for="(item,index) in categories"
                                        :label="item.categoriesName"
                                        :value="item.categoriesId"
                                ></el-option>
                            </el-select>

                            <el-form-item  class="m-1">
                                <el-input v-model="topForm.proName" placeholder="查询商品名称" ></el-input>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary"  @click="chageProList()"  icon="search":loading="loading">查询</el-button>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary" @click="groupForm('topForm')">重置</el-button>
                            </el-form-item>
                        </el-form>
                        <div>
                            <el-table ref="multipleTable" :data="tablePro" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="productName" label="已上架商品"></el-table-column>
                                <el-table-column prop="kioskNo" label="售货机ID"></el-table-column>
                                <el-table-column prop="categoriesName" label="品类"></el-table-column>
                            </el-table>
                            <div class="block">
                                <el-pagination
                                        @current-change="handleCurrentChange"
                                        @size-chahange="handleSizeChange"
                                        :current-page="currentpage"
                                        :page-count="pagesCount"
                                        :page-sizes="pagesizes"
                                        :page-size="pagesize"
                                        :total="pagesCount"
                                        layout=" total, prev, pager, next, jumper"
                                >
                                </el-pagination>
                            </div>
                        </div>

                        <span slot="footer" class="dialog-footer">
                        <el-button @click="closeDialog()">取 消</el-button>
                        <el-button type="primary" @click="addProGroup()">添 加</el-button>
                    </span>
                    </el-dialog>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>

</template>
<script>
    export default {
        data() {
            var verifyGroupName = (rule, value, callback) => {
                this.updateFlag = true;
                if (value == '') {
                    this.$message({showClose: true, message: "请输入分组名称！", type: 'error'});
                } else {
                    var params = {tenantId:this.getcookie('storeId'),groupName:this.ecxForm.groupName};
                    //异步请求
                    this.$http.get(this.productURL+"/vueFeign/verifyGroupName",{params:params})
                        .then(response => {
                            if (response.status == 200) {
                                if (response.body.Code == '500') {
                                    this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                                } else {
                                    if(response.body.Data.length > 0 && this.$route.query.groupName != value){
                                        this.updateFlag = false;
                                        this.$message({showClose: true, message: "分组已存在请重新输入！", type: 'error'});
                                    }
                                }
                            }
                        });
                }
            };
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                //页眉设置参数
                procurrentpage: 1,//当前页数默认是1
                propagesCount: 0, //总数默认0
                propagesizes: [10, 20, 30],//条数列
                propagesize: 10,//行数
                proactiveNum: 0, //默认起始行数
                proendNum: 10,//默认结束行数
                activeName: 'first',
                isorgsubmit:false,
                loading:false,
                dialogVisible:false,
                updateFlag:true,
                batchDelFlag:true,
                proCondition:'0',
                proName:'',
                groupId:'',
                ecxForm:{
                    kioskNo:'K1-A112',
                    groupName:'',
                    firstPriority:'0',
                    secondPriority:'0',
                },
                topForm:{
                    proName:'',
                    categoriesName:'',
                },
                tableData3:[],
                primaryData3:[],
                tablePro:[],
                categories:[],//品类
                addProGroupList:[],
                delProGroupList:[],
                actrules:{
                    groupName: [
                        { required: true, message: '请输入商品分组名称', trigger: 'blur' },
                        { min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' },
                        { validator: verifyGroupName, trigger: 'blur' },
                    ],
                }

            };
        },
        created(){
            this.groupId = this.$route.query.groupId;
            this.ecxForm.groupName = this.$route.query.groupName;
            this.ecxForm.firstPriority = this.$route.query.firstPriority;
            this.ecxForm.secondPriority = this.$route.query.secondPriority;
            this.ecxForm.kioskNo = this.$route.query.kioskNo;
            this.categorieslist();
            this.proList();
            this.proGroupList();
        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.proList();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.proList();
            },
            proSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.propagesize=val
                this.proactiveNum=(val*this.procurrentpage)-val;
                this.proendNum=(val*this.procurrentpage)
                this.filtratePro();
                //数目变更
            },
            proCurrentChange(val){
                this.procurrentpage=val;
                this.proactiveNum=(this.propagesize*val)-this.propagesize
                this.proendNum=(this.propagesize*val)
                this.filtratePro();
            },
            closeDialog(){
                this.topForm.categoriesName = this.topForm.categoriesName;
                this.topForm.proName = this.topForm.proName;
                this.dialogVisible = false
            },
            chageProList(){
                this.currentpage = 1;
                this.activeNum = 0,this.endNum = 10;
                this.proList();
            },
            groupForm(formName) {
                this.currentpage = 1;
                this.activeNum = 0,this.endNum = 10;
                this.topForm.proName='';
                this.topForm.categoriesName='';
                this.proList();
            },
            handleSelectionChange(val) {
                this.addProGroupList = val;
                console.log(this.addProGroupList)
            },
            batchhandleSelectionChange(val) {
                this.delProGroupList = val;
                if(this.delProGroupList.length > 0){
                    this.batchDelFlag = false;
                }else {
                    this.batchDelFlag = true;
                }
                console.log(this.delProGroupList)
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            close(){
                this.$router.push( {path:"groupManager"});
            },
            handleClose(done) {
                this.closeDialog();
            },
            categorieslist(){
                //数据请求
                var params = {tenantId:this.getcookie('storeId')};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/categoriesList",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.categories = response.body.Data;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.isorgsubmit = false;
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            proList(){
                //数据请求
                var params = {tenantId:this.getcookie('storeId'),categoriesId:this.topForm.categoriesName,
                    productName:this.topForm.proName,kioskNo:this.ecxForm.kioskNo,groupId:this.groupId
                    ,active:this.activeNum,len:this.pagesize};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/proList",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.tablePro = response.body.Data.proList;
                                this.pagesCount = response.body.Data.count.length;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            addProGroup() {
                if(this.groupId != '' && this.groupId != undefined){
                    console.log(this.addProGroupList.length);
                    if(this.addProGroupList.length > 0){
                        for (var i = 0; i < this.addProGroupList.length; i++) {
                            var SKU = this.addProGroupList[i].SKU;

                            //数据请求
                            var params = {groupId: this.groupId, SKU: SKU, sequenceNum: '0'};
                            //异步请求
                            this.$http.post(this.productURL + "/vueFeign/saveProGroup", params)
                                .then(response => {
                                    if (response.status === 200) {
                                        if (response.body.Code == '200') {
                                            this.tablePro = response.body.Data;
                                        } else if (response.body.code == '500') {
                                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                                        }
                                    }
                                    this.proList();
                                    this.proGroupList();
                                }, function (response) {
                                    this.loading = false;
                                    this.$message({
                                        showClose: true,
                                        message: '网络异常',
                                        type: 'error'

                                    });
                                })
                        }
                    }else {
                        this.$message({showClose: true, message: "请选择商品信息", type: 'error'});
                    }
                }else {
                    this.$message({showClose: true, message: "请先添加分组基本信息", type: 'error'});
                }
            },
            proGroupList(){
                //数据请求
                var params = {groupId: this.groupId,proName:this.proName};
                //异步请求
                this.$http.post(this.productURL + "/vueFeign/findProGroup", params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == '200') {
                                this.tableData3 = response.body.Data.groupList;
                                this.pagesCount = response.body.Data.count;
                                this.primaryData3 = response.body.Data.groupList;
                                this.changePro();
                            } else if (response.body.code == '500') {
                                this.$message({showClose: true, message: response.body.msg, type: 'error'});
                            }
                        }
                        this.proList();
                    }, function (response) {
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            delProGroup(groupId,SKU){
                //数据请求
                var params = {groupId: groupId,SKU:SKU};
                //异步请求
                this.$http.post(this.productURL + "/vueFeign/delProGroup", params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == '200') {

                            } else if (response.body.code == '500') {
                                this.$message({showClose: true, message: response.body.msg, type: 'error'});
                            }
                        }
                        this.proGroupList();
                    }, function (response) {
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            batchDel(){
                console.log(this.delProGroupList);
                for (var i = 0; i < this.delProGroupList.length; i++) {
                    var SKU = this.delProGroupList[i].SKU;
                    var groupId = this.delProGroupList[i].groupId;
                    this.delProGroup(groupId,SKU)
                }
            },
            changePro(){
                this.procurrentpage = 1;
                this.proactiveNum = 0,this.proendNum = 10;
                this.filtratePro();
            },
            filtratePro(){
                var outData = [];
                var upData = [];
                for (var i=0;i<this.primaryData3.length;i++){
                    if(this.primaryData3[i].proStatus == '0'){
                        outData.push(this.primaryData3[i])
                    }else {
                        upData.push(this.primaryData3[i])
                    }
                }
                if(this.proCondition == '1'){
                    var tableArr = JSON.parse(JSON.stringify(upData))
                    this.tableData3 = tableArr.splice(this.proactiveNum,this.proendNum);
                    this.propagesCount = upData.length;
                }else if(this.proCondition == '2'){
                    var tableArr = JSON.parse(JSON.stringify(outData))
                    this.tableData3 = tableArr.splice(this.proactiveNum,this.proendNum);
                    this.propagesCount = outData.length;
                }else {
                    var tableArr = JSON.parse(JSON.stringify(this.primaryData3))
                    this.tableData3 = tableArr.splice(this.proactiveNum,this.proendNum);
                    this.propagesCount = this.primaryData3.length;
                }
            },
            updateProGroup(row){
                var params = {SKU:row.SKU,sequenceNum:row.sequenceNum,groupId:this.groupId};
                //异步请求
                this.$http.post(this.productURL + "/vueFeign/updateGroupPro", params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == '200') {
                                this.$message({ showClose: true, message: "修改成功",  type: 'success' });
                            } else if (response.body.code == '500') {
                                this.$message({showClose: true, message: response.body.msg, type: 'error'});
                            }
                        }
                        this.proGroupList();
                    }, function (response) {
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            submitForm(){
                if(this.ecxForm.groupName != '' && this.ecxForm.groupName != null && this.updateFlag){
                    var params = {groupName:this.ecxForm.groupName,kioskNo:this.ecxForm.kioskNo,groupId:this.groupId,
                        firstPriority:this.ecxForm.firstPriority,secondPriority:this.ecxForm.secondPriority};
                    //异步请求
                    this.$http.post(this.productURL + "/vueFeign/updateGroup", params)
                        .then(response => {
                            if (response.status === 200) {
                                if (response.body.Code == '200') {
                                    this.$route.query.groupName = this.ecxForm.groupName;
                                    this.$message({ showClose: true, message: "修改成功",  type: 'success' });
                                } else if (response.body.code == '500') {
                                    this.$message({showClose: true, message: response.body.msg, type: 'error'});
                                }
                            }
                            this.proGroupList();
                        }, function (response) {
                            this.loading = false;
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                }
            },
            verifyGroupName(){
                var params = {tenantId:this.getcookie('storeId'),groupName:this.ecxForm.groupName};
                //异步请求
                this.$http.get(this.productURL+"/vueFeign/verifyGroupName",{params:params})
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == '500') {
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            } else {
                                if(response.body.Data.length > 0){
                                    this.$message({showClose: true, message: "分组已存在请重新输入！", type: 'error'});
                                }
                            }
                        }
                    });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// groupModify.vue?30c1c87d